const isCallable = (value: unknown): value is CallableFunction => typeof value === 'function';

/**
 * Init a wrapper around `console` to add a defined prefix.
 */
export class ConsoleLogger {
  readonly #console = { ...console };

  get console() {
    return this.#console;
  }

  constructor(prefix: string) {
    const clone = { ...console };

    // Create wrapper functions for each console method
    this.#console = Object.keys(clone).reduce((obj, method) => {
      const fn = clone[method];
      if (!isCallable(fn)) return obj;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const newFn = function (...args: any[]) {
        // Add prefix to the first argument if it's a string
        if (typeof args[0] === 'string') {
          args[0] = `[${prefix}] ${args[0]}`;
        } else {
          // Insert prefix as the first argument
          args.unshift(`[${prefix}]`);
        }

        // Call the original method
        try {
          fn.apply(console, args);
        } catch (err) {
          console.warn(`[${prefix}] Could not log: `, ...args, err);
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any;

      return { ...obj, [method]: newFn };
    }, clone);
  }
}

export type Logger = ConsoleLogger['console'];
